import api from './index';
import { getRepetitionIntervalType } from '../components/Events/utils/serieDialogUtils';

const BASE = '/reduction';

export const getReductions = async ({
    location,
    worktype,
    start,
    end,
}: {
    location: number | number[];
    worktype: number | number[];
    start: string;
    end: string;
}) => {
    return api.get(BASE, { params: { start, end, location, worktype } }).then((res) => res.data);
};

export const postReduction = async (data: any) => {
    return api.post(BASE, { data });
};

export const deleteReduction = async ({ id, deleteSerie }: { id: number; deleteSerie: boolean }) => {
    await api.delete(`${BASE}/${id}`, { params: { deleteSerie } });
};

export const getReductionById = async (id: number) => {
    return api.get(`${BASE}/${id}`).then((res) => {
        const reduction = res.data;
        if (reduction.reductionSerie) {
            reduction.reductionSerie.repetitionIntervalType = getRepetitionIntervalType(reduction.reductionSerie);
        }

        return reduction;
    });
};

export const getTotalReductionsForAllLocations = async () => {
    return api.get(`${BASE}/totalReductionsForAllLocations`).then((res) => res.data);
};
